import { useContext } from 'preact/hooks';

import DialogButton, { type DialogButtonTemplateParams } from 'Components/smallComponents/dialogButton';
import type { TemplateFunction, TemplateResult } from 'Components/types';

import GarageContext from './garageContext';

interface Props {
  template: TemplateFunction<DialogButtonTemplateParams>;
}

export default function AddButton({ template }: Props): TemplateResult {
  const { closeGarage } = useContext(GarageContext);

  const props = { template, onClick: closeGarage, dialogName: 'VehicleWidgetDialog' };
  return <DialogButton {...props} />;
}
